import React from 'react';
import { AlertTriangleIcon, ActivityIcon, BatteryWarningIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-[#0d1529]" data-id="element-182">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-183">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-184">
          <span className="text-[#00d4ff] font-semibold tracking-widest uppercase text-sm" data-id="element-185">
            El Problema Real
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mt-2 mb-4 uppercase" data-id="element-186">
            El Villano Invisible:
          </h2>
          <div className="w-24 h-1 bg-[#00d4ff] mx-auto rounded-full" data-id="element-187"></div>
        </div>

        {/* Content Blocks */}
        <div className="space-y-10" data-id="element-188">
          <div className="flex flex-col md:flex-row gap-6 items-start bg-[#111827] p-6 rounded-2xl border border-slate-700/50" data-id="element-189">
            <div className="bg-orange-500/10 p-3 rounded-full shrink-0 border border-orange-500/30" data-id="element-190">
              <AlertTriangleIcon className="w-8 h-8 text-orange-400" data-id="element-191" />
            </div>
            <div data-id="element-192">
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-193">
                No son las calorías, es el Cortisol
              </h3>
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-194">
                A los 20, podías quemar una pizza entera con solo salir a
                bailar. A los 40, el estrés crónico mantiene tu cuerpo en modo
                "supervivencia". Tu cerebro le ordena a tu abdomen:{' '}
                <span className="bg-yellow-500/20 text-yellow-300 px-1 font-bold rounded" data-id="element-195">
                  "¡Guarda grasa! La necesitamos para la emergencia".
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start bg-[#111827] p-6 rounded-2xl border border-slate-700/50" data-id="element-196">
            <div className="bg-red-500/10 p-3 rounded-full shrink-0 border border-red-500/30" data-id="element-197">
              <ActivityIcon className="w-8 h-8 text-red-400" data-id="element-198" />
            </div>
            <div data-id="element-199">
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-200">
                Resistencia a la Insulina: El candado metabólico
              </h3>
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-201">
                Después de décadas de picos de azúcar, tus células se han vuelto
                "sordas" a la insulina. ¿El resultado? Todo lo que comes se
                almacena directamente como grasa visceral — dura y peligrosa —
                en lugar de convertirse en energía.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start bg-[#111827] p-6 rounded-2xl border border-slate-700/50" data-id="element-202">
            <div className="bg-slate-500/10 p-3 rounded-full shrink-0 border border-slate-500/30" data-id="element-203">
              <BatteryWarningIcon className="w-8 h-8 text-slate-400" data-id="element-204" />
            </div>
            <div data-id="element-205">
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-206">
                Por qué el cardio te está engordando?
              </h3>
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-207">
                Correr 1 hora al día estresa aún más a un cuerpo que ya está al
                límite. Aumentas el cortisol, destruyes masa muscular (tu motor
                quema-grasa) y terminas con más hambre y menos energía. Es un
                círculo vicioso.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 bg-[#111827] p-8 rounded-xl border border-[#00d4ff]/20 text-center" data-id="element-208">
          <p className="text-xl font-medium text-white" data-id="element-209">
            "Necesitas dejar de luchar contra tu biología y empezar a trabajar{' '}
            <span className="text-[#00d4ff] font-bold" data-id="element-210">CON</span> ella."
          </p>
        </div>
      </div>
    </section>;
}